import * as basicLightbox from 'basiclightbox';

const self = {};

self.initialise = function () {
  const el = document.querySelectorAll('.js-btn-lightbox');

  if (!el) {
    return;
  }

  Array.from(el).forEach((item) => {
    item.addEventListener('click', (e) => {
      const videoURLPath = item.dataset.video;
      const instance = basicLightbox.create(`
      <div class="responsive-wrapper">
        <iframe src='${videoURLPath}?autoplay=1' frameborder="0"></iframe>
      </div>
      `, {
          afterShow: () => {
            // initialiseVideo();
          },
        });

      instance.show(() => {
        document.querySelector('.basicLightbox').innerHTML += `
        <div class="close-lightbox-wrapper">
          <button class="btn--close js-close-lightbox">
            <svg class="icon-svg icon-close" viewBox="0 0 50 50">
              <use xlink:href="/src/img/svg/icon-close.svg#icon-close" />
            </svg>
          </button>
        </div>
        `;

        document.querySelector('.js-close-lightbox').addEventListener('click', () => {
          instance.close();
        });
      });

      e.preventDefault();
      instance.show();
    });
  });
};

module.exports = self;


// WEBPACK FOOTER //
// ./sitefiles/scripts/global/rebuild-components/init-lightbox.js